import { FelaCSS, spacing } from '@bridebook/ui';

interface IStyles {
  sectionsWrapper: FelaCSS;
}

const styles = (): IStyles => ({
  sectionsWrapper: {
    gap: spacing[6],
    desktopDesign: {
      gap: spacing[8],
    },
  },
});

export default styles;
